/**
 * @copyright 2019 @ DigiNet
 * @author VINHLE
 * @create 2019/03/28 15:37
 * @update 2019/03/28 15:37
 */
import Api from "../../../services/api";
import * as types from "../../types";

export function getData(param, cb) {
    return () => {
        Api.put('/w18f4070/load-grid', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    }
}

//Load combo ware house
export function loadCboSalesOffice(cb) {
    return (dispatch) => {
        Api.get('/w18f4070/load-cbo-sales-office')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadCboSalesOfficeComplete(result.data));
                }
            });
    };
}

function loadCboSalesOfficeComplete(data) {
    return {
        type: types.W18_W18F4070_LOAD_CBO_SALES_OFFICE_SUCCESS,
        data: data
    }
}

export function loadCboSalesGroup(param, cb) {
    return () => {
        Api.put('/w18f4070/load-cbo-sales-group', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    }
}

export function loadCboSalesPerson(param, cb) {
    return () => {
        Api.put('/w18f4070/load-cbo-sales-person', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    }
}
